import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { WarrantyOperationType } from '@app/shared/enums/WarrantyOperationType.enum';

@Pipe({
    name: "warrantyOperationTypePipe",
    standalone: false
})
export class WarrantyOperationTypePipe implements PipeTransform {
  public operationType = WarrantyOperationType;
  public warrantyOperationTypes: any[] = [];

  constructor(public translate: TranslateService) {
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.' + key);
    }
  }

  getList() {
    this.warrantyOperationTypes = [];

    for (const [propertyKey, propertyValue] of Object.entries(WarrantyOperationType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.warrantyOperationTypes.push({id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)});
    }

    return this.warrantyOperationTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(WarrantyOperationType)) {
      if (propertyValue == Id) {
        return {id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(WarrantyOperationType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
